export default "__VITE_ASSET__CIUg3k57__"